<div id="notfound">
  <div class="notfound">
    <div class="notfound-404">
      <h1>4<span>0</span>4</h1>
    </div>
    <h2>A página que você solicitou não pode ser encontrada!</h2>
    <div class="notfound-search">
      <button (click)="goToHome()" type="button" class="o-button -blue">Voltar a homepage</button>

    </div>
  </div>
</div>